import { render, staticRenderFns } from "./report-tip.vue?vue&type=template&id=fca1daec&scoped=true"
import script from "./report-tip.vue?vue&type=script&lang=ts"
export * from "./report-tip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca1daec",
  null
  
)

export default component.exports